export default __webpack_public_path__ + "assets/icons/success.741fa863.svg";